// Offline layer. The IndexedDB caches and the capture queue under
// web/src/storage/ are already view-agnostic, so core just re-exports
// them under one namespace and pairs them with the network-status hook.
//
// The flush-on-reconnect wiring — re-sending queued captures through the
// turn engine — lives in CoreProvider, which has the engine to drive it.
// Note (vs. the old MobileShell): queued captures re-home into the active
// thread; the legacy hidden "Mobile Capture" thread is retired.

import { useNetworkStatus } from '../hooks/useNetworkStatus'
import * as captureQueue from '../storage/capture_queue'

export * as cardsCache from '../storage/cards_cache'
export * as projectsCache from '../storage/projects_cache'
export { captureQueue }
export { isNetworkError } from '../storage/network_error'
export type { QueuedCapture } from '../storage/capture_queue'

export interface OfflineQueue {
  /** Live `navigator.onLine` mirror. */
  online: boolean
  enqueue: typeof captureQueue.enqueue
  listQueued: typeof captureQueue.listAll
  flushQueue: typeof captureQueue.flush
}

export function useOfflineQueue(): OfflineQueue {
  const { online } = useNetworkStatus()
  return {
    online,
    enqueue: captureQueue.enqueue,
    listQueued: captureQueue.listAll,
    flushQueue: captureQueue.flush,
  }
}
